import { Fragment } from 'react';
import PropTypes from 'prop-types';

const AddressLines = ({ address }) => (
  <>
    {Object.values(address).reduce((accumulator, line) => {
      if (typeof line === 'string' && line.trim() !== '') {
        accumulator.push(
          <Fragment key={line}>
            {line}
            <br />
          </Fragment>,
        );
      }
      return accumulator;
    }, [])}
  </>
);

AddressLines.address = {
  address: PropTypes.object.isRequired,
};

export default AddressLines;
